// 🔴🔴 N°743 — UN HISTORIQUE MONTRE UN LIBELLÉ, ⛔ PAS UN NOM DE COLONNE.
//
// ⚠️ MESURÉ : la description d'historique est fabriquée côté serveur avec les
// CLÉS BRUTES de l'update (`metier_hub/core/database.py:1346` —
// `f"Modification: {', '.join(update_data.keys())}"`). Ce ⛔ n'est donc PAS
// spécifique à trois champs : TOUS les noms de colonnes s'affichent, pour tous
// les tenants, depuis toujours. JJ l'a vu sur « visiteur_amo, visiteur_email,
// visiteur_telephone » parce que ce nom-là porte en plus le mot d'un AUTRE
// métier.
//
// 🔑 POURQUOI TRADUIRE À L'AFFICHAGE, et ⛔ PAS à l'écriture : le journal est
// une trace d'AUDIT — il doit garder le nom RÉEL du champ modifié. Traduire à
// l'écriture ⛔ ne réparerait que les entrées FUTURES et laisserait illisible
// tout l'historique déjà en base. Ici, une seule fonction sert les deux.
//
// ⚠️ `visiteur_amo` est le SEUL champ dont le libellé dépend du métier : chez un
// tenant d'AMO c'est « Visiteur AMO » (⛔ inchangé), ailleurs « Visiteur ».
import { hasDossierAmo } from "./tenantProfile";

//: Nom de colonne → libellé lisible. ⛔ Un champ absent d'ici ⛔ n'est PAS une
//: erreur : on rend alors le nom brut « déminé » (⛔ jamais rien).
const LIBELLES = {
  visiteur_email: "E-mail du visiteur",
  visiteur_telephone: "Téléphone du visiteur",
  visiteur_id: "Visiteur (fiche)",
  installateur_nom: "Installateur",
  client_nom: "Nom du client",
  date_visite: "Date de visite",
  contrat_signe: "Contrat signé",
  mandat_signe: "Mandat signé",
  statut: "Statut",
  statut_global: "Statut global",
  reference: "Référence",
  montant_amo: "Montant AMO",
  montant_travaux: "Montant des travaux",
  visite_payee: "Visite payée",
  type_projet: "Type de projet",
  adresse_travaux: "Adresse des travaux",
  updated_at: "Dernière modification",
  verrouille: "Verrouillé",
  notes: "Notes",
};

/** Le libellé d'un champ, lisible, adapté au métier du tenant. */
export function libelleChamp(nom) {
  const cle = String(nom || "").trim();
  if (!cle) return "";
  if (cle === "visiteur_amo") return hasDossierAmo() ? "Visiteur AMO" : "Visiteur";
  if (LIBELLES[cle]) return LIBELLES[cle];
  // ⚠️ Repli LISIBLE : underscores en espaces, première lettre en capitale.
  // ⛔ On ⛔ ne masque PAS un champ inconnu — masquer une modification dans un
  // journal d'audit serait pire que l'afficher techniquement.
  const mots = cle.replace(/_/g, " ").trim();
  return mots.charAt(0).toUpperCase() + mots.slice(1);
}

/**
 * Réécrit une description d'historique du serveur.
 * « Modification: visiteur_amo, visiteur_email » → « Modification : Visiteur,
 * E-mail du visiteur ». ⛔ Toute autre description est rendue TELLE QUELLE.
 */
export function descriptionLisible(description) {
  const texte = String(description || "");
  const m = texte.match(/^Modification\s*:\s*(.+)$/);
  if (!m) return texte;
  const champs = m[1].split(",").map((c) => libelleChamp(c)).filter(Boolean);
  return `Modification : ${champs.join(", ")}`;
}
